import 'bee-icon/build/Icon.css'
export * from 'bee-icon';
export { default } from 'bee-icon';


// WEBPACK FOOTER //
// ./src/components/bee/icon/index.js